module.exports = __webpack_public_path__ + "5781df03431a40d9e12d16ca6ff816a4.png";